<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: "ghost" | "primary" | "danger";
    size?: "md" | "sm";
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
  }>(),
  {
    variant: "ghost",
    size: "md",
    type: "button",
    disabled: false,
  },
);
</script>

<template>
  <button
    :type="type"
    class="zw-btn"
    :class="{
      'zw-btn-primary': variant === 'primary',
      'zw-btn-danger': variant === 'danger',
      'zw-btn-sm': size === 'sm',
    }"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<style>
.zw-btn {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0.45rem 0.75rem;
  border-radius: 0.3rem;
  font-family: var(--font-ui);
  font-size: 0.95rem;
  color: var(--text-muted);
  cursor: pointer;
  transition:
    color var(--duration-fast) var(--ease-out-quart),
    background-color var(--duration-fast) var(--ease-out-quart);
}

.zw-btn:hover:not(:disabled) {
  color: var(--text-strong);
  background: var(--hover-fill);
}

.zw-btn:focus-visible {
  outline: 2px solid var(--color-zw-amber);
  outline-offset: 2px;
}

.zw-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.zw-btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
}

.zw-btn-primary {
  color: var(--text-strong);
  background: color-mix(in oklch, var(--color-zw-amber) 16%, transparent);
  font-weight: 600;
}

.zw-btn-primary:hover:not(:disabled) {
  background: color-mix(in oklch, var(--color-zw-amber) 24%, transparent);
}

.zw-btn-danger {
  color: var(--danger);
}

.zw-btn-danger:hover:not(:disabled) {
  color: var(--danger);
  background: var(--hover-fill);
}
</style>
